/**
 * @generated SignedSource<<1673cb75657bea6600dbf2ac725637e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
import { FragmentRefs } from "relay-runtime";
export type LinkedContent_files$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string | null;
  readonly type: FileType | null;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedFileItem_file">;
  readonly " $fragmentType": "LinkedContent_files";
}>;
export type LinkedContent_files$key = ReadonlyArray<{
  readonly " $data"?: LinkedContent_files$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedContent_files">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "LinkedContent_files",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkedFileItem_file"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "b234c72bc0ab287a48991d872a7d1d07";

export default node;
